import { ref } from 'vue';
import { defineStore } from 'pinia';

export type NhsAppPlatform = 'android' | 'ios' | 'none';

// NB. used for NhsApp & NhsWebApp
export const useNhsAppStore = defineStore('nhs-app', () => {
  const windowHasNhsSdk = ref(false);
  const appPlatform = ref<NhsAppPlatform>('none');
  const isOpenInNhsApp = ref(false);

  const isNhsWebApp = ref(false);

  function setWindowHasNhsSdk(value: boolean): void {
    windowHasNhsSdk.value = value;
  }

  function setAppPlatform(value: NhsAppPlatform): void {
    appPlatform.value = value;
  }

  function setIsOpenInNhsApp(value: boolean): void {
    // TODO: confirm this is set early enough in the app for setting correct session end path
    console.log('setIsOpenInNhsApp', value);
    isOpenInNhsApp.value = value;
    if (value) {
      setIsNhsWebApp(false);
    }
  }

  // This is true for NhsApp or NhsWebApp
  function setIsNhsWebApp(value: boolean): void {
    isNhsWebApp.value = value;
  }

  function setNhsState(payload: {
    windowHasNhsSdk: boolean;
    appPlatform: NhsAppPlatform;
    isOpenInNhsApp: boolean;
  }) {
    windowHasNhsSdk.value = payload.windowHasNhsSdk;
    appPlatform.value = payload.appPlatform;
    isOpenInNhsApp.value = payload.isOpenInNhsApp;
  }

  function resetNhsState(): void {
    windowHasNhsSdk.value = false;
    appPlatform.value = 'none';
    isOpenInNhsApp.value = false;
    isNhsWebApp.value = false;
  }

  return {
    windowHasNhsSdk,
    appPlatform,
    isOpenInNhsApp,
    isNhsWebApp,
    setWindowHasNhsSdk,
    setAppPlatform,
    setIsOpenInNHSApp: setIsOpenInNhsApp,
    setIsNhsWebApp,
    setNhsState,
    resetNhsState,
  };
});
